	$('.carousel').carousel({
	  interval: 5000,
   	  pause: "false"
	});
	$(document).ready(function(){
$('.navbar-toggler').click(function(){
$('.navbar-toggler').toggleClass('showtoggle');
$('#Menu-Overlay').toggleClass('active');
});	
$('#Menu-Overlay').click(function(){
$('.navbar-toggler').removeClass('showtoggle');
$('#Menu-Overlay').removeClass('active');
$('.navbar-collapse').removeClass('show');
});	      
});	
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 30) {
        $(".header_sec").addClass("fixed");
    } else {
        $(".header_sec").removeClass("fixed");
    }
});

// $(document).ready(function() {
// var owl = $('.mic_sec .owl-carousel');
  // owl.owlCarousel({
  	// stagePadding:75,
    // margin:26,
    // dots: false,
    // autoplay: true,
    // nav: true,
    // dotsEach: false,
    // loop: true,
    // responsive: {
      // 0: {	
        // items: 2
      // },
      // 480: {		
        // items: 3
      // },
      // 575: {		
        // items: 2
      // },
      // 768: {
        // items: 3
      // },         
      // 992: {
        // items: 3
      // },
      // 1200: {
        // items: 3
      // }
    // }
  // });
// });
$(document).ready(function() {
var owl = $('.mic_sec .owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 2
      },
      480: {	
        items: 2
      },
      575: {	
        items: 2
      },
      768: {
        items: 3
      },         
      992: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
});




$(document).ready(function() {
var owl = $('.best_sdll_sec .owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 2
      },
      480: {	
        items: 2
      },
      575: {	
        items: 2
      },
      768: {
        items: 3
      },         
      992: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});





$(document).ready(function() {
var owl = $('.bannerSec .owl-carousel');
  owl.owlCarousel({
    margin:0,
    dots: true,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      1200: {
        items: 1
      }
    }
  });
});





$(document).ready(function() {
var owl = $('.spcSec .owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:10,
        items: 1,
        stagePadding: 20,
      },
      450: {	
      	margin:10,
        items:1,
        stagePadding: 50,
      },
      575: {	
      	margin:10,
        items: 2
      },
      768: {
        items: 2
      },         
      992: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.shop_lvel_sec .owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    autoplay: false,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:10,
        items: 1,
        autoplay: true,
      },
      450: {	
      	margin:10,
        items: 2,
        autoplay: true,
      },
      575: {	
      	margin:10,
        items: 2,
        autoplay: true,
      },
      768: {
        items: 2,
        autoplay: true,
      },         
      992: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.braSec .owl-carousel');
  owl.owlCarousel({
    margin:26,
    dots: false,
    autoplay: false,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:10,
        items: 2
      },
      480: {	
      	margin:10,
        items: 2
      },
      575: {
      	margin:10,	
        items: 2
      },
      768: {
        items: 3
      },         
      992: {
        items: 4
      },
      1200: {
        items: 4
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.what_aressec .owl-carousel');
  owl.owlCarousel({
    margin:0,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 2
      },
      480: {	
        items: 2
      },
      575: {
        items: 3
      },
      768: {
        items: 3
      },         
      992: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.product-grids');
  owl.owlCarousel({
    margin:0,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      480: {	
        items: 2
      },
      575: {
        items: 2
      },
      768: {
        items: 2
      },         
      992: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
});

$(document).ready(function(){
$('#open').click(function(){
$('#hide').slideToggle();
});
});

$(document).ready(function(){
$(".plyBtn").click(function(){
  $(".posterImg").addClass("main");
  $('video').attr("autoplay"," ");
  $(this).css("display", "none");
});
});
$(document).ready(function() {
    $('.hdtp .owl-carousel').owlCarousel({
      items: 3,
      loop: true,
      margin: 10,
      autoWidth:true,
      // navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
      autoplay: true,
      slideTransition: "linear",
      autoplayTimeout: 0,
      smartSpeed: 3000,
      fluidSpeed: true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      responsiveClass: true,
      nav: false,
      dots: false,
      responsive: {
        0:{
            items:2,
        },
        400:{
            items:3,
        },
        600:{
            items:3,
        },
        1000:{
            items:4,
        },
        1920 : {
            items: 6
        }
      }
    });
  });


$(document).ready(function() {    
$(".detailsDescrp li a").click(function(event) {        
    event.preventDefault();        
    $(this).parent().addClass("actv");        
    $(this).parent().siblings().removeClass("actv");        
    var tab = $(this).attr("href");        
    $(".Product-Description").not(tab).css("display", "none");    
    $(tab).fadeIn();    
    });
});

let staticPlaceholder = "Search for ";
      let searcharray = [
        "Pre Workout",
        "Gainers",
        "BCaa",
        "Protein Powder",
        "Weight Gainer",
        "Protein Powder"
      ];
      let dynamicPlaceholder = "";
      let searchPlaceholderIndex = 0;
      let offset = 0;
      let len = searcharray.length;
      let forwards = true;
      let skip_count = 0;
      let skip_delay = 15;
      let speed = 100;
      function type() {
        setInterval(function() {
          if (forwards) {
            if (offset >= searcharray[searchPlaceholderIndex].length) {
              ++ skip_count;
              if (skip_count == skip_delay) {
                forwards = false;
                skip_count = 0;
              }
            }
          } else {
            if (offset == 0) {
              forwards = true;
              searchPlaceholderIndex++;
              offset = 0;
              if (searchPlaceholderIndex >= len) {
                searchPlaceholderIndex = 0;
              }
            }
          } dynamicPlaceholder = searcharray[searchPlaceholderIndex].substr(0, offset);
          if (skip_count == 0) {
            if (forwards) {
              offset++;
            } else {
              offset--;
            }
          }
          document.querySelectorAll('.search__input').forEach(search_el => {
            search_el.setAttribute("placeholder", staticPlaceholder + dynamicPlaceholder);
          });
        }, speed);
      };
      type();
